import { TGetReceiptPdfConfig } from "@elixir/types";
import { getReceiptConfig } from "apis";

const receiptConfigMap: Record<string, TGetReceiptPdfConfig | undefined> = {};

export class ReceiptConfigManager {
  async get({
    doctor_oid,
    clinic_id,
  }: {
    doctor_oid: string;
    clinic_id: string;
  }): Promise<TGetReceiptPdfConfig | undefined> {
    const cacheKey = `${doctor_oid}-${clinic_id}`;
    if (receiptConfigMap[cacheKey]) {
      return receiptConfigMap[cacheKey];
    }

    const response = await getReceiptConfig({ doctor_oid, clinic_id });

    if (response.success && response.data?.[0]) {
      receiptConfigMap[cacheKey] = response.data[0];
      return receiptConfigMap[cacheKey];
    }

    return undefined;
  }

  invalidateConfigOfClinic(cid: string, doctor_oid: string) {
    receiptConfigMap[`${doctor_oid}-${cid}`] = undefined;
  }
}
